module.exports = __webpack_public_path__ + "static/media/ErrorImportPotential.03c3fc17.svg";